import { useEffect, useCallback } from 'react';
import flatten from 'ramda/src/flatten';
import { Role } from '../types';
import { isDefined } from '../utils';
const useGetUserPermissionBase = ({ userId, user, userGroups, getUser, getUserGroups, }) => {
    const getUserMemoized = useCallback(() => {
        if (userId && !user) {
            getUser(userId);
        }
    }, [getUser, userId, user]);
    //if a user has global permissions, display that global permissions
    //otherwise, display the highest permission after checking
    //accessResources from the user itself as well as accessResources from any associated userGroups
    const getUserGroupsMemoized = useCallback(() => {
        const userGroupIds = user === null || user === void 0 ? void 0 : user.groupIds;
        if (userGroupIds && userGroupIds.length > 0 && userGroups.length === 0) {
            getUserGroups(userGroupIds);
        }
    }, [getUserGroups, user, userGroups]);
    useEffect(() => {
        getUserMemoized();
    }, [getUserMemoized]);
    useEffect(() => {
        getUserGroupsMemoized();
    }, [getUserGroupsMemoized]);
    //we have a hack where users have a "global" permissions
    //can be "Viewer"/"Manager"/"Admin" (like normal permissions), can switch between orgs
    //only EB users should have global permissions, i believe
    const globalPermissions = user === null || user === void 0 ? void 0 : user.role;
    //this shows sites/orgs that a user has direct access to
    const userAccessResources = user === null || user === void 0 ? void 0 : user.accessResources;
    //this shows sites/orgs that a user has access to via association with userGroup
    const userGroupAccessResources = flatten(userGroups.map((ug) => ug.accessResources));
    const highestRole = determineHighestRole(userAccessResources, userGroupAccessResources);
    if (isDefined(globalPermissions)) {
        return {
            isGlobal: true,
            role: globalPermissions,
        };
    }
    return {
        isGlobal: false,
        role: highestRole,
    };
};
const determineHighestRole = (userAccessResources = [], userGroupAccessResources) => {
    const allAccessResources = [
        ...userAccessResources,
        ...userGroupAccessResources,
    ];
    if (allAccessResources.some((r) => r.role === Role.ADMIN)) {
        return Role.ADMIN;
    }
    if (allAccessResources.some((r) => r.role === Role.MANAGER)) {
        return Role.MANAGER;
    }
    if (allAccessResources.some((r) => r.role === Role.VIEWER)) {
        return Role.VIEWER;
    }
    return null;
};
export default useGetUserPermissionBase;
